// Copyright (c) 2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { SendanorIcon } from "../types/SendanorIcon";

export const SHELL_FEATURES = [
    'public_html',
    'gitolite',
    'screen',
    'port',
    'irc-irssi',
    'irc-ipv6',
    'cron',
    'email-mutt',
    'games-adom',
    'games-nethack',
    'games-slashem',
];

export const SHELL_FEATURE_IMAGE : {[key: string]: SendanorIcon} = {
    'public_html': SendanorIcon.WebHotelsIcon,
    'gitolite': SendanorIcon.ShellsIcon,
    'screen': SendanorIcon.WebHotelsIcon,
    'port': SendanorIcon.VirtualServersIcon,
    'irc-irssi': SendanorIcon.ShellsIcon,
    'irc-ipv6': SendanorIcon.InternetIcon,
    'cron': SendanorIcon.DatabasesIcon,
    'email-mutt': SendanorIcon.EmailIcon,
    'games-adom': SendanorIcon.WebrtcIcon,
    'games-nethack': SendanorIcon.WebrtcIcon,
    'games-slashem': SendanorIcon.WebrtcIcon,
};